<template>
	<div class="sidenav">
    <h6 class="sidenav-heading text-muted">
      <span>Advanced Filter</span>
      <b-button class='button-sidenav-toggle' @click="showHideSideBar" v-if="$store.state.sidebarStatus"><i class="material-icons">clear</i></b-button>
    </h6>
    <div class="filter-top-container">
      <div class="d-flex flex-column align-items-start filter-contents">
        <b-form-group
          id="commodity-form"
          label="Commodity"
          label-for="commodity"
        >
          <b-form-input
            id="commodity"
            type="text"
            placeholder="Commodity, use comma (',') for multiple value"
            v-model="filterForm['APPROVED_COMMODITIES']"
            @keydown.native="enterSearch"
          />
        </b-form-group>

        <b-form-group
          id="vendor-name-form"
          label="Vendor Name"
          label-for="vendor-name"
        >
        <b-form-input
            id="vendor-name"
            type="text"
            placeholder="Vendor Name, use comma (',') for multiple value"
            v-model="filterForm['VENDOR_NAME']"
            @keydown.native="enterSearch"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Organizations">
          <b-form-checkbox-group
            class="organization-checkbox d-flex flex-inline align-items-center justify-content-start"
          >
            <b-form-checkbox
              v-for="(option, index) in options"
              :key="index"
              :value="option.value"
              class="d-flex align-items-center justify-content-center"
              v-model="organization"
              @keydown.native="enterSearch"
            >
              {{ option.text }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

        <!-- City -->
        <b-form-group
          id="city-form"
          label="City"
          label-for="city"
        >
          <b-form-input
            id="city"
            type="text"
            placeholder="City, use comma (',') for multiple value"
            v-model="filterForm.CITY"
            @keydown.native="enterSearch"
          ></b-form-input>
        </b-form-group>

        <!-- City -->
        <b-form-group
          id="province-form"
          label="Province"
          label-for="province"
        >
          <b-form-input
            id="province"
            type="text"
            placeholder="Province, use comma (',') for multiple value"
            v-model="filterForm.PROVINCE"
            @keydown.native="enterSearch"
          ></b-form-input>
        </b-form-group>

        <b-form class="datepicker-form-container">
          <div class="label-period">
            <label>Period (PO, CSI, Event, SPM)</label>
          </div>
          <div class="datepicker-container">
            <datepicker
              :bootstrap-styling="true"
              :value="filterForm['PERIOD_FROM']"
              :format="format"
              @selected="selectFrom"
              placeholder="From"
              calendar-class="datepicker-el"
              input-class="datepicker-input"
            ></datepicker>
            <label class="labelDate"> : </label>
            <datepicker
              :bootstrap-styling="true"
              :value="filterForm['PERIOD_TO']"
              :format="format"
              @selected="selectTo"
              placeholder="To"
              calendar-class="datepicker-er"
              input-class="datepicker-input"
            ></datepicker>
          </div>
        </b-form>

        <div
          class="d-flex flex-column align-items-start added-filter"
          v-for="(filter, index) in appliedFilters"
          :key="index"
          :id="`${filter.key}_form`"
        >
          <b-form class="datepicker-form-container" v-if="filter.field_name == 'LEGAL_DOCUMENT_EXPIRED_DATE'">
            <div class="label-period">
              <label>{{ filter.label}}</label>
            </div>
            <div class="datepicker-container">
              <datepicker
                :bootstrap-styling="true"
                :value="filterForm[`LEGAL_DOCUMENT_EXPIRED_MIN`]"
                :format="format"
                @selected="fromLegalDoc"
                placeholder="From"
                calendar-class="datepicker-el"
                input-class="datepicker-input"
              ></datepicker>
              <label class="labelDate"> : </label>
              <datepicker
                :bootstrap-styling="true"
                :value="filterForm[`LEGAL_DOCUMENT_EXPIRED_MAX`]"
                :format="format"
                @selected="toLegalDoc"
                placeholder="To"
                calendar-class="datepicker-er"
                input-class="datepicker-input"
              ></datepicker>
            </div>
          </b-form>

          <b-form class="datepicker-form-container" v-if="filter.field_name == 'K3L_PREQ_END_DATE'">
            <div class="label-period">
              <label>{{ filter.label}}</label>
            </div>
            <div class="datepicker-container">
              <datepicker
                :bootstrap-styling="true"
                :value="filterForm[`K3L_PREQ_END_DATE_MIN`]"
                :format="format"
                @selected="fromK3lEnd"
                placeholder="From"
                calendar-class="datepicker-el"
                input-class="datepicker-input"
              ></datepicker>
              <label class="labelDate"> : </label>
              <datepicker
                :bootstrap-styling="true"
                :value="filterForm[`K3L_PREQ_END_DATE_MAX`]"
                :format="format"
                @selected="toK3lEnd"
                placeholder="To"
                calendar-class="datepicker-er"
                input-class="datepicker-input"
              ></datepicker>
            </div>
          </b-form>

          <b-form-group
            v-if="filter.type == 'input'"
            :id="`${filter.key}_form`"
            :label="filter.label"
          >
            <b-form-input
              :id="filter.label"
              type="text"
              :placeholder="`${filter.label}, use comma (',') for multiple value`"
              v-model="filterForm[filter.field_name]"
              @keydown.native="enterSearch"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            v-if="filter.type == 'number'"
            :id="`${filter.key}_form`"
            :label="filter.label"
          >
            <div
              class="ig"
            >
              <b-form-input
                :id="filter.key"
                type="number"
                placeholder="Min"
                class="ig-input mr-2"
                v-model="filterForm[`${filter.field_name}_MIN`]"
              />
              <label class="labelDate"> : </label>
              <b-form-input
                :id="filter.key"
                type="number"
                placeholder="Max"
                class="ig-input ml-2"
                v-model="filterForm[`${filter.field_name}_MAX`]"
                @keydown.native="enterSearch"
              />
            </div>
          </b-form-group>

          <b-form-group
            v-if="filter.type == 'list'"
            :id="`${filter.key}_form`"
            :label="filter.label"
          >
            <b-form-select 
              :options="modesList[filter.field_name]"
              v-model="filterForm[filter.field_name]"
              class="list-menu"
            ></b-form-select>
          </b-form-group>
        </div>
      </div>
    </div>

		<!-- Filter Buttons -->
    <div class='filter-bottom-container'>
      <div class="filter-buttons">
        <b-button
          class="text-left d-flex align-items-center justify-content-between btn-more-filter"
          block
          text="white"
          @click="addFilter"
        >
          <span>Add More Filter</span>
        </b-button>
        <b-button class="ml-2 mr-2 btn-reset" @click="resetFilter"><span>Reset</span></b-button>
        <b-button class=" btn-search" text="white" @click="runSearch"><span>{{ $store.state.datatable.loading ? "Loading ..." : "Search"}}</span></b-button>
      </div>
    </div>
		<!-- End of Filter Buttons -->
	</div>
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import {api} from '../services/config'
import axios from 'axios'
export default {
	name: 'Sidenav',
  components: {
    Datepicker
  },
	data() {
    return {
      modesList : {
        CSI_FINAL_ADJ :  [
          {value : null, text : 'Please choose'},
          {value : 1, text : "CSI Sangat Buruk"},
          {value : 2 , text : "CSI Tidak Memuaskan"}, 
          {value : 3, text : "CSI Cukup Memuaskan"}, 
          {value : 4 , text : "CSI Memuaskan"},
          {value : 5, text : "CSI Sangat Memuaskan"}
        ],
        HASIL_FINANSIAL_ASSESSMENT : ['Yes', 'No'],
        IUJP : ['Yes', 'No'],
        SIO : ['Yes', 'No'],
        LEGAL_DOCUMENT_EXPIRED : [
		{value : 'yes', text : 'Expired'},
		{value : 'no', text : 'No'}
	],
        TKDN : ["Yes", "No"],
        RISK_CATEGORY : [
          {value : null, text : 'Please choose'},
          {value : '70,100', text : "HIGH"}, 
          {value : '50,69', text : "MEDIUM B1"}, 
          {value : '35,49', text : "MEDIUM B2"}, 
          {value : '25,34', text : "LOW C1"}, 
          {value : '0,24', text : "LOW C2"}
        ],
        VENDOR_CATEGORY : [
          {value : null, text : 'Please choose'},
          {value : '95,100', text : "Sangat Memuaskan"}, 
          {value : '80,94', text : "Memuaskan"}, 
          {value : '70,79', text : "Cukup Memuaskan"}, 
          {value : '51,69', text : "Tidak Memuaskan"}, 
          {value : '0,50', text : "Sangat Buruk"}
        ],
        STATUS_SUPPLIER : ["Active", "Block"]
      },
      modesNumber : ['<','>'],
      organization: [],
      options: [
        { text: 'BCE', value: 'BCE' },
        { text: 'GEMS', value: 'GEMS' },
        { text: 'BKES', value: 'BKES' },
        { text: 'Ariba', value : 'Others'}
      ],
      defaultDate: null,
      format: 'd MMM yyyy',
      filterForm : {
        ORGANIZATION : [],
        PERIOD_FROM :  `${moment().subtract(30, 'days').format("YYYY-MM-DD")}`,
        PERIOD_TO : `${moment(new Date()).format("YYYY-MM-DD")}`,
        VENDOR_ID_ARIBA : null,
        VENDOR_ID_SAPBC : null,
        VENDOR_ID_SAPGEMS : null,
        VENDOR_ID_BKES : null,
        VENDOR_NAME : null,
        APPROVED_COMMODITIES : null,
        CITY : null,
        PROVINCE : null,
        COUNTRY : null,
        ADDRESS : null,
        HASIL_FINANSIAL_ASSESSMENT : null,
        IUJP : null,
        SCORE_FOR_K3L_PREQUALIFICATION_MIN : null,
        SCORE_FOR_K3L_PREQUALIFICATION_MAX : null,
        K3L_REMAINING_DAYS_MIN : null,
        K3L_REMAINING_DAYS_MAX : null,
        CSI_SCORING_MIN : null,
        CSI_SCORING_MAX : null,
        EVENT_AWARDED_MIN : null,
        EVENT_AWARDED_MAX : null,
        EVENT_PARTICIPATED_MIN : null,
        EVENT_PARTICIPATED_MAX : null,
        SPM_SCORING_MIN : null,
        SPM_SCORING_MAX : null,
        TOTAL_PO_RELEASED_MIN : null,
        TOTAL_PO_RELEASED_MAX : null,
        VALUE_IDR_MIN : null,
        VALUE_IDR_MAX : null,
        K3L_PREQ_END_DATE_MIN : null,
        K3L_PREQ_END_DATE_MAX : null,
        LEGAL_DOCUMENT_EXPIRED_DATE_MIN : null,
        LEGAL_DOCUMENT_EXPIRED_DATE_MAX : null,
        SPM_PERFORMANCE_PERIOD_MIN : null,
        SPM_PERFORMANCE_PERIOD_MAX : null,
        STATUS_SUPPLIER : null,
        BADAN_USAHA : null,
        VENDOR_CATEGORY : null,
        RISK_CATEGORY : null,
        CSI_FINAL_ADJ : null
      },
      range: {
        from: null,
        to: null
      }
    }
  },
  computed: {
    appliedFilters: function() { return this.$store.state.datatable.fieldsToFilter }
  },
  methods: {
    addFilter() {
      const self = this
      self.$store.dispatch('filter/toggleShowFilter')
      this.$ga.event({
        eventCategory: 'Advanced Filter',
        eventAction: 'click',
        eventLabel: 'ADD MORE FILTER'
      });
    },
    selectFrom(value) {
      const self = this
      let date = new Date(value)
      self.filterForm.PERIOD_FROM= `${moment(date).format("YYYY-MM-DD")}`
    },
    selectTo(value) {
      const self = this
      let date = new Date(value)
      self.filterForm.PERIOD_TO = `${moment(date).format("YYYY-MM-DD")}`
    },
    selectDate(value) {
      const self = this
      let date = new Date(value)
      self.filterForm.K3L_PREQUALIFICATION_END_DATE_MAX = `${moment(date).format("YYYY-MM-DD")}`
    },
    fromLegalDoc(value) {
      const self = this
      let date = new Date(value)
      self.filterForm.LEGAL_DOCUMENT_EXPIRED_DATE_MIN= `${moment(date).format("YYYY-MM-DD")}`
    },
    toLegalDoc(value) {
      const self = this
      let date = new Date(value)
      self.filterForm.LEGAL_DOCUMENT_EXPIRED_DATE_MAX = `${moment(date).format("YYYY-MM-DD")}`
    },
    fromK3lEnd(value) {
      const self = this
      let date = new Date(value)
      self.filterForm.K3L_PREQ_END_DATE_MIN= `${moment(date).format("YYYY-MM-DD")}`
    },
    toK3lEnd(value) {
      const self = this
      let date = new Date(value)
      self.filterForm.K3L_PREQ_END_DATE_MAX = `${moment(date).format("YYYY-MM-DD")}`
    },
    showHideSideBar(){
      const self = this
      self.$store.dispatch('toggleSidebar', false)
    },
    enterSearch(event){
      if(event.which === 13){
        this.runSearch()
      }
    },
    runSearch(){
      this.$ga.event({
        eventCategory: 'Advanced Filter',
        eventAction: 'click',
        eventLabel: 'SEARCH'
      });
      const self = this
      if(self.filterForm.PERIOD_FROM > self.filterForm.PERIOD_TO){
        self.$bvToast.toast('Date From is greater than date to', {
          title: 'Filter error!',
          toaster: 'b-toaster-top-center',
          solid: true,
          appendToast: false,
          variant: 'danger'
        })
      } else {
        const dataFilter = Object.entries(self.filterForm)
        let filtered = []
        let manualFilter = []
        let query = ''
        let manualQuery
        let organizationCheck = {
          ORGANIZATION_BCE : 'no',
          ORGANIZATION_BKES : 'no',
          ORGANIZATION_GEMS : 'no',
          ORGANIZATION_OTHERS : 'no'
        }
        dataFilter.map(filter => {
          if(filter[1]){
            if(filter[0] == 'ORGANIZATION'){
              for(let i in self.organization){
                if(self.organization[i] == "BCE"){
                  filtered.push(['ORGANIZATION_BCE', 'yes'])
                }
                if(self.organization[i] == "GEMS"){
                  filtered.push(['ORGANIZATION_GEMS', 'yes'])
                }
                if(self.organization[i] == "BKES"){
                  filtered.push(['ORGANIZATION_BKES', 'yes'])
                }
                if(self.organization[i] == "Others"){
                  filtered.push(['ORGANIZATION_OTHERS', 'yes'])
                }
              }
            } else if(filter[0] == 'VENDOR_NAME' && filter[1] && filter[1] !== ''){
              filtered.push([filter[0], filter[1].replace(/, /ig, ',')])
            } else if(filter[0] == 'RISK_CATEGORY' && filter[1] && filter[1] !== ''){
              filtered.push(['RISK_CATEGORY_MIN', `${filter[1].split(',')[0]}` ])
              filtered.push(['RISK_CATEGORY_MAX', `${filter[1].split(',')[1]}` ])
            }else if(filter[0] == 'VENDOR_CATEGORY' && filter[1] && filter[1] !== ''){
              manualFilter.push('VENDOR_CATEGORY_MIN', `${filter[1].split(',')[0]}`)
              manualFilter.push('VENDOR_CATEGORY_MAX', `${filter[1].split(',')[1]}`)
            } else if(filter[0] == 'CSI_FINAL_ADJ' && filter[1] && filter[1] !== ''){
              manualFilter.push(filter[0], `${filter[1]}`)
            } else if(filter[0] == "K3L_REMAINING_DAYS_MIN"){
              manualFilter.push(filter[0], filter[1])
            } else if(filter[0] == "K3L_REMAINING_DAYS_MAX"){
              manualFilter.push(filter[0], filter[1])
            } else if(filter[0] == "CSI_SCORING_MIN"){
              manualFilter.push(filter[0], filter[1])
            } else if(filter[0] == "CSI_SCORING_MAX"){
              manualFilter.push(filter[0], filter[1])
            } else if(filter[0] == "EVENT_AWARDED_MIN"){
              manualFilter.push(filter[0], filter[1])
            }else if(filter[0] == "EVENT_AWARDED_MAX"){
              manualFilter.push(filter[0], filter[1])
            }else if(filter[0] == "EVENT_PARTICIPATED_MIN"){
              manualFilter.push(filter[0], filter[1])
            }else if(filter[0] == "EVENT_PARTICIPATED_MAX"){
              manualFilter.push(filter[0], filter[1])
            }else if(filter[0] == "SPM_SCORING_MIN"){
              manualFilter.push(filter[0], filter[1])
            }else if(filter[0] == "SPM_SCORING_MAX"){
              manualFilter.push(filter[0], filter[1])
            }else if(filter[0] == "TOTAL_PO_RELEASED_MIN"){
              manualFilter.push(filter[0], filter[1])
            }else if(filter[0] == "TOTAL_PO_RELEASED_MAX"){
              manualFilter.push(filter[0], filter[1])
            }else if(filter[0] == "PO_VALUE_MIN"){
              manualFilter.push(filter[0], filter[1])
            }else if(filter[0] == "PO_VALUE_MAX"){
              manualFilter.push(filter[0], filter[1])
            }else {
              filtered.push([filter[0], filter[1].replace(/, /ig, ',')])
            }
          }
        })

        if(filtered.length > 0){
          filtered.map(data => {
              query += `&${data[0]}=${data[1]}`
          })
        }
        self.$store.dispatch('datatable/setQuery', query)
        self.$store.dispatch('datatable/setManualFilter', manualFilter)
        self.$store.dispatch('datatable/setFilter')
      }
    },
    async resetFilter(){
      const self = this
      self.filterForm = {
        ORGANIZATION : [],
        PERIOD_FROM : `${moment().subtract(30, 'days').format("YYYY-MM-DD")}`,
        PERIOD_TO : `${moment(new Date()).format("YYYY-MM-DD")}`,
        VENDOR_ID_ARIBA : null,
        VENDOR_ID_SAPBC : null,
        VENDOR_ID_SAPGEMS : null,
        VENDOR_ID_BKES : null,
        VENDOR_NAME : null,
        APPROVED_COMMODITIES : null,
        CITY : null,
        PROVINCE : null,
        COUNTRY : null,
        ADDRESS : null,
        HASIL_FINANSIAL_ASSESSMENT : null,
        IUJP : null,
        SCORE_FOR_K3L_PREQUALIFICATION_MIN : null,
        SCORE_FOR_K3L_PREQUALIFICATION_MAX : null,
        K3L_REMAINING_DAYS_MIN : null,
        K3L_REMAINING_DAYS_MAX : null,
        CSI_SCORING_MIN : null,
        CSI_SCORING_MAX : null,
        EVENT_AWARDED_MIN : null,
        EVENT_AWARDED_MAX : null,
        EVENT_PARTICIPATED_MIN : null,
        EVENT_PARTICIPATED_MAX : null,
        SPM_SCORING_MIN : null,
        SPM_SCORING_MAX : null,
        TOTAL_PO_RELEASED_MIN : null,
        TOTAL_PO_RELEASED_MAX : null,
        VALUE_IDR_MIN : null,
        VALUE_IDR_MAX : null,
        K3L_PREQ_END_DATE_MIN : null,
        K3L_PREQ_END_DATE_MAX : null,
        LEGAL_DOCUMENT_EXPIRED_DATE_MIN : null,
        LEGAL_DOCUMENT_EXPIRED_DATE_MAX : null,
        SPM_PERFORMANCE_PERIOD_MIN : null,
        SPM_PERFORMANCE_PERIOD_MAX : null,
        STATUS_SUPPLIER : null,
        BADAN_USAHA : null,
        VENDOR_CATEGORY : null,
        RISK_CATEGORY : null,
        CSI_FINAL_ADJ : null
      }
      self.organization = []
      this.$ga.event({
        eventCategory: 'Advanced Filter',
        eventAction: 'click',
        eventLabel: 'RESET'
      });
      await self.$store.dispatch('datatable/resetState')
      await self.$store.dispatch('setSearchNull', null)
    }
  }
}
</script>

<style lang="scss">
@import '~/assets/scss/components/sidenav.scss';
</style>
